import React from 'react';
import { InputNumber } from 'antd';
import { Field, ToggleField } from '@src/components/Common/Form';

const LIMIT_RULE = [{ type: 'number' as const, min: 1, message: 'Must be at least 1' }];

/**
 * The ceilings a model is called under, shared by the GenAI and ChatCompletion
 * forms — the backend's `RateLimitConfigMixin`. Empty means no ceiling.
 */
const RateLimitFields = () => (
    <>
        <Field name={['extra_data', 'token_limit_1m']} label="Tokens / min" span={3} rules={LIMIT_RULE}>
            <InputNumber placeholder="No limit" style={{ width: '100%' }} min={1} step={1} />
        </Field>

        <Field name={['extra_data', 'requests_limit_1m']} label="Requests / min" span={3} rules={LIMIT_RULE}>
            <InputNumber placeholder="No limit" style={{ width: '100%' }} min={1} step={1} />
        </Field>

        <Field name={['extra_data', 'token_limit_1d']} label="Tokens / day" span={3} rules={LIMIT_RULE}>
            <InputNumber placeholder="No limit" style={{ width: '100%' }} min={1} step={1} />
        </Field>

        <Field name={['extra_data', 'requests_limit_1d']} label="Requests / day" span={3} rules={LIMIT_RULE}>
            <InputNumber placeholder="No limit" style={{ width: '100%' }} min={1} step={1} />
        </Field>

        {/* a third of the row, so it shares one with what a call costs */}
        <ToggleField
            name={['extra_data', 'fail_on_rate_limit']}
            span={4}
            label="Fail on rate limit"
            hint="Reject with HTTP 429 instead of buffering and retrying."
        />
    </>
);

export default RateLimitFields;
